import React, {FC, ReactElement, useEffect, useState} from 'react';
import './Richtext.scss';
import styled from 'styled-components';
import RichTextEditor from './RichTextEditor';

export type richTextProps = {
    defaultContent: string | null,
    content: string,
    editorPlugins: any | null,
    path: {
        slideIndex: number,
        comboIndex: number,
        setIndex: number,
        groupIndex: number,
        elementIndex: number | null,
    } | null,
    placeholder: string|null,
    isButton: boolean|null,
    isSettingsTool:boolean|null
}

type richTextElementProps = {
    // horizontalAlignment:string,
}


const RichTextElement = styled.div<richTextElementProps>`
  &.content {
    text-align: inherit;
  }
`;


const RichText: FC<richTextProps> = ({...props}): ReactElement => {

    let defaultContent = props.defaultContent || '';
    let content = props.content;
    const [ckeditorId, setId] = useState('inline-editor-' + Date.now());

    const finalContent = (content && content.length) ? content : defaultContent;

    const isEditor = props.editorPlugins?.ckeditor;

    useEffect(() => {
        window.addEventListener("scroll", handleRKPIPlugins);
    }, []);

    function handleRKPIPlugins() {
        //Highlighted sentences
        let highLightElements = document.querySelectorAll('.highlight');
        if(!highLightElements || !highLightElements.length) return;
        highLightElements.forEach(function (item: Element, index: number) {
            if (isEditor) return item.classList.remove('activehigh');
            if(item.classList.contains('activehigh')) return;
            let isInView = isScrolledIntoView(item);
            if (!isInView) return;
            item.classList.remove('activehigh');
            let isFirst = index === 0;
            return addClassRecursiveIterator(item, isFirst);
        });


        //RKPI from ckeditor
        let rkpiElements = document.querySelectorAll('[data-start-counter-class^=rkpi]');
        if(!rkpiElements || !rkpiElements.length) return;
        rkpiElements.forEach(function (item: Element) {
            if(item.classList.contains('rkpiActivated')) return;
            let isInView = isScrolledIntoView(item);
            if (!isInView) return;
            let from = item.getAttribute('data-from');
            let to = item.getAttribute('data-to');
            let prefix = item.getAttribute('data-prefix');
            let suffix = item.getAttribute('data-suffix');
            let speed = getRkpiSpeed(item.getAttribute('data-speed'));
            animateValue(item, Number(from), Number(to), speed, prefix, suffix);
            return item.classList.add('rkpiActivated');
        });
    }

    function getRkpiSpeed(speed:string|null) {
        let finalSpeed = 2000;
        if(speed) {
            try {
                finalSpeed = Number(speed)
            } catch (e) {
                finalSpeed = 2000;
            }
        }
        return finalSpeed;
    }

    function addClassRecursiveIterator(element:any, first = false) {
        var ttl = first ? 0 : 200;
        setTimeout(function () {
            element.classList.add('activehigh');
        }, ttl)
    }

    function isScrolledIntoView(el: any) {
        let top = el.offsetTop;
        let left = el.offsetLeft;
        let width = el.offsetWidth;
        let height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.scrollY + window.innerHeight) &&
            left < (window.scrollY + window.innerWidth) &&
            (top + height) > window.scrollY &&
            (left + width) > window.scrollX
        );
    }

    function animateValue(element:any, start:number, end:number, duration:number, prefix:string|null = null, suffix:string|null = null) {
        let startTimestamp:any = null;
        const step = (timestamp:any) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            element.innerHTML = Math.floor(progress * (end - start) + start);
            if(prefix) element.innerHTML = prefix + element.innerHTML;
            if(suffix) element.innerHTML = element.innerHTML + suffix;
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    if(isEditor) {
        return <RichTextEditor {...props} path={props.path} uniqueId={ckeditorId}/>
    }
    else {
        return <RichTextElement className="content" dangerouslySetInnerHTML={{ __html: finalContent }}/>
    }

};

const settings = [
    [
        {
            settingName: 'CKEditor',
        }
    ]
];


export default {
    RichText,
    settings,
    label: 'Text'
};
